import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import StateSelect from '../forms/stateSelect';
import { saveClientUser } from 'actions/user';
import { bindActionCreators } from 'redux';
import {
	Features,
	PlanSelector,
	FileUploader,
	AvatarSelector,
	MapSelector
} from '../';
import {
	fetch,
	validateEmail
} from 'api'; //from 'api/api'
import * as Actions from 'actions';

class UserForm extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'UserForm';
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            username : '',
            password : '',
            password_confirm : '',
            password_valid: null,
            password_error: null,
            password_match_error: null,
            password_match : true,
            name : {
            	first : '',
            	last : ''
            },
            email : '',
            email_valid : true,
            personal_phone : '',
            work_phone : '',
            address : {
                street : '',
                city : '',
                state : '',
                zip : '',
                country : '',
                state_is_valid: true,
                zip_is_valid : true,
                same_as_billing : false
            },
            purchased_maps : [],
            billing_address : {
                street : '',
                city : '',
                state : '',
                zip : '',
                country : ''
            },
            role : '',
            features : [],
            send_email_confirmation : true,
            dirty : false,
            focused_item : '',
            enabled : true
        }

        this.validatePassword = this.validatePassword.bind(this);
        this.confirmPassword = this.confirmPassword.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderRoles = this.renderRoles.bind(this);
        this.handleClickLoginCredTab = this.handleClickLoginCredTab.bind(this);
        this.handleClickGeneralInfoTab = this.handleClickGeneralInfoTab.bind(this);
        this.handleClickProfilePicTab = this.handleClickProfilePicTab.bind(this);
        this.handleClickPasswordTab = this.handleClickPasswordTab.bind(this);
        this.handleClickFeaturesTab = this.handleClickFeaturesTab.bind(this);
        this.handleClickPlansAndMapsTab = this.handleClickPlansAndMapsTab.bind(this);
        this.handleClickCompanyTab = this.handleClickCompanyTab.bind(this);
        this.handleEnableAccountChange = this.handleEnableAccountChange.bind(this);
				this.handleEnableAccountValidationChange = this.handleEnableAccountValidationChange.bind(this);
    }

    validatePassword(pass) {

        var a = pass.match(/.{8}.*/g);
        var b = pass.match(/[a-z]{1}/g);
        var c = pass.match(/[A-Z]{1}/g);
        var d = pass.match(/[0-9]{1}/g);

        var error = [];
        if(!a) {
            error.push('at least 8 characters');
        }
        if(!b) {
            error.push('at least one lowercase letter');
        }
        if(!c) {
            error.push('at least one uppercase letter');
        }
        if(!d) {
            error.push('at least one number');
        }
        var message = "";
        for(var i = 0; i < error.length; i++) {
            if(i != error.length - 1)
                message += error[i] + ', ';
            else
                message += 'and '+ error[i] + '.'
        }

        if(!a || !b || !c || !d)
            return {
                password_valid : false,
                password_error : "Password must have " + message,
                password : pass
            }
        else
            return {
                password_valid : true,
                password_error : null,
                password : pass
            }
    }

    confirmPassword(pass) {
        if(pass != this.props.user.password)
            return {
                password_match_error : "Passwords must match.",
                passwords_match : false,
                password_confirm : pass
            }
        else {
            return {
                password_match_error : null,
                passwords_match : true,
                password_confirm : pass
            }
        }
    }

    handleChange(event) {
        var state = {...this.state, ...this.props.user};

    		// ADDED : Set default role
        if(state.role === '')
        	state.role = this.props.roleManagement.roles[0].name

        var item = state;
        var value = event.target.value;
        var keys = event.target.name;

        keys = keys.split('.');
        var iterations = keys.length - 1;
        for (var i = 0; i < iterations; i++) {
            item = item[keys.shift()];
        };
        //Comment: Invented this function here. Universal handle-change function.
        switch(event.target.name) {
            case 'address.same_as_billing': case 'send_email_confirmation':
                item[keys[0]] = event.target.checked;
                break;
            case 'password':
                state = Object.assign({},state, this.validatePassword(value));
                break;
            case 'password_confirm':
                state = Object.assign({},state, this.confirmPassword(value));
                break;
            case 'name.first': case 'name.last':
                if(value = value.match(/([a-zA-Z]*)/g))
                    item[keys[0]] = value[0];
                break;
            case 'address.city': case 'billing_address.city':
                if(value.match(/([a-zA-Z\s]*)/g))
                    item[keys[0]] = value;
                break;
            case 'email':
                item[keys[0]] = value;
                state['email_valid'] = validateEmail(value);
                break;
            case 'personal_phone' :
            		state['personal_phone'] = value;
            		break;
            case 'work_phone' :
            		state['work_phone'] = value;
            		break;
            case 'address.zip':case 'billing_address.zip':
                if(value.match(/^[0-9]{5}(-[0-9]{1,5})?$/g)) {
                    item.zip_is_valid = true;
                }
                if(value.match(/^[0-9]{0,5}(-[0-9]{0,5})?$/g)) {
                    item[keys[0]] = value;
                }
                break;
            case 'avatar' :
            		state.avatar = event.target.id;
            		break;
            case 'purchased_maps' :
	            	if(event.target.checked) {
	            		state['purchased_maps'] = [...state['purchased_maps'], event.target.id];
								}
	            	else {
            			state['purchased_maps'] = state['purchased_maps'].filter(m => m != event.target.id);
	            	}
	            	break;
            case 'choose-role' :
            		state = {...state, role : value}
            		break;
            case 'plans' :
            		if((typeof value === 'object') && value._id)
            			value = value._id

            		let filtered_features = this.props.users.tmp_user_features.filter(f => {
            			if(f.path.startsWith('/Plans/'))
            				return false
            			else
            				return f._id
            		})

            		state = {...state, features : [...filtered_features, ...value.map(v => v._id)]};
            		break;
            case 'features' :
            		if(value === 'on') {
            			state = {...state, features : [...state.features, ...event.features]}
            		}
            		else if(value === 'off'){
            			event.features.forEach(event_feature => {
	            			let index = state.features.findIndex(state_feature => state_feature === event_feature)
	            			if(event !== -1) {
		            			state = {
		            				...state, features :
		            				[
		            					...state.features.filter((e, i) => i < index),
		            					...state.features.filter((e, i) => i > index)
		            				]
		            			}
		            		}
		            		else
		            			console.log('Error unselecting feature');
		            	})
            		}
            case 'account_user_limit' :
            		if(value.match(/^[0-9]*$/) != null) {
            			state['account_user_limit'] = value
            		}
            		break;
            case 'enabled' :
            		state.enabled = this.props.user ? !this.props.user.enabled : false;
								break;
						case 'validation.enabled':
								state.validation = {...(state.validation || {}), enabled: value};
								break;
            default:
                item[keys[0]] = value;
                break;
        }
        this.setState({dirty : true});
        this.props.updateTmpUser(state);
    }

    renderRoles(current_role) {
    	return (
    		<option
    			key={current_role._id}
    			value={current_role.name}
    			name='choose-role'
    			onClick={this.handleChange}>
    			{current_role.name}
    		</option>
    	)
    }

    handleClickLoginCredTab() {
    	this.props.setOpenTab('login_cred');
    }

    handleClickPasswordTab() {
    	this.props.setOpenTab('password');
    	if(!this.props.users.password_tab_dirty)
    		this.props.setPasswordTabDirty()
    }

    handleClickGeneralInfoTab() {
    	this.props.setOpenTab('gen_info');
    	if(!this.props.users.gen_info_tab_dirty)
    		this.props.setGenInfoTabDirty();
    }

    handleClickProfilePicTab() {
    	this.props.setOpenTab('profile_pic');
    	if(!this.props.users.profile_pic_tab_dirty)
    		this.props.setGenInfoTabDirty();
    }

    handleClickPlansAndMapsTab() {
    	this.props.setOpenTab('plans_maps');
    }

    handleClickFeaturesTab() {
    	this.props.setOpenTab('features');
    }

    handleClickCompanyTab() {
    	this.props.setOpenTab('company')
    }

    handleEnableAccountChange() {
    	let event = {
    		target : {
	    		name : 'enabled',
	    		value : !this.props.user.enabled
    		}
    	}

    	this.handleChange(event)
    }
		handleEnableAccountValidationChange() {
			let event = {
				target : {
					name: 'validation.enabled',
					value: this.props.user.validation? !this.props.user.validation.enabled : false,
				}
			}
			this.handleChange(event);
		}
    render() {
        var _self = this;
        var user;
        if (this.props.user) {
        	user = (Object.keys(this.props.user).length === 0) ? {...this.state} : {...this.state, ...this.props.user};
        	// Add names. Needed due to missmatch in name representatino
        	//	in global state and database
        }
        else
        	user = {...this.state};

        var users = this.props.users;
        var {
            role,
            personal_phone,
            work_phone
        } = user;

        let current_user = this.props.users.user;

        var Error = (()=>{
            if(user.errors && user.errors.length > 0) {
              return (
                <div className="form-group">
                  <div className="col-xs-12 col-md-4">
                    <div className="col-xs-12">
                      <div className="alert alert-danger" role="alert"><strong>Warning!</strong>
                      <ul>
	                      {users.errors.map(err => {
                          return <li>{err.message}</li>
	                      })}
                      </ul>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
        })();

        var passwordClass = classNames({
            'has-error' : (user.password_error == null)? false : !user.password_valid,
            'has-success' : user.password != ''? user.password_valid : false
        });

        var passwordConfirmClass = classNames({
            'has-error' : (!this.state.dirty || user.password_confirm == '') ? false : !user.passwords_match,
            'has-success' : user.password_confirm != '' ? user.passwords_match : false
        });

        var emailClass = classNames({
            'has-error' : user.email? false : !user.email_valid,
            'has-success' : user.email? user.email_valid : false
        });

        var login_cred_class_name;
        var general_info_class_name;
        var plans_and_maps_class_name;
        var company_class_name;
        var profile_pic_class_name;
        var password_class_name;
        var features_class_name;
        var enabled_account_class_name;
				var enabled_account_validation_class_name;
        if(this.props.users.open_tab === 'login_cred' || this.props.users.open_tab === '')
        	login_cred_class_name = 'active'
        else
        	login_cred_class_name = '';
        if(this.props.users.open_tab === 'gen_info')
        	general_info_class_name = 'active'
        else
        	general_info_class_name = '';
        if(this.props.users.open_tab === 'profile_pic')
        	profile_pic_class_name = 'active'
        else
        	profile_pic_class_name = '';
        if(this.props.users.open_tab === 'plans_maps')
        	plans_and_maps_class_name = 'active'
        else
        	plans_and_maps_class_name = '';
        if(this.props.users.open_tab === 'company')
        	company_class_name = 'active'
        else
        	company_class_name = '';
        if(this.props.users.open_tab === 'password')
        	password_class_name = 'active'
        else
        	password_class_name = '';
        if(this.props.users.open_tab === 'features')
        	features_class_name = 'active'
        else
        	features_class_name = '';

        if(this.props.user && this.props.user.enabled)
        	enabled_account_class_name = 'ios-switch on';
        else
        	enabled_account_class_name = 'ios-switch off';

				if(this.props.user && this.props.user.validation && this.props.user.validation.enabled) {
					enabled_account_validation_class_name = 'ios-switch on';
				}
				else {
					enabled_account_validation_class_name = 'ios-switch off';
				}

        return (
        	<div id='user-form-container'>
	        	<div className='tabs'>
	        		<ul className='nav nav-tabs'>
	        			<li
	        				className={login_cred_class_name}
	        				onClick={this.handleClickLoginCredTab}>
	        				<a aria-expanded='false'>
		        				Login Credentials
	        				</a>
	        			</li>
	  						<li
	        				onClick={this.handleClickPasswordTab}
	        				className={password_class_name}>
	        				<a aria-expanded='false'>
		        				Password
	        				</a>
	        			</li>
	        			<li
	        				onClick={this.handleClickGeneralInfoTab}
	        				className={general_info_class_name}>
	        				<a aria-expanded='false'>
		        				General User Info
	        				</a>
	        			</li>
	        			<li
	        				onClick={this.handleClickProfilePicTab}
	        				className={profile_pic_class_name}>
	        				<a aria-expanded='false'>
		        				Profile Picture and Avatar
	        				</a>
	        			</li>
	        			{(() => {
	        				if(this.props.hasPermission('/Account Management/Users/Edit/User Details/') &&
	        					!this.props.users.creating_user &&
	        					this.props.user &&
	        					!(current_user._id === this.props.user._id)) {
	        					return (
	        						<li
				        				onClick={this.handleClickFeaturesTab}
				        				className={features_class_name}>
				        				<a aria-expanded='false'>
					        				Features
				        				</a>
				        			</li>
	        					)
	        				}
	        			})()}
	        			{(() => {
	        				if(this.props.users.user.is_admin) {
	        					return (
	        						<li
				        				onClick={this.handleClickPlansAndMapsTab}
				        				className={plans_and_maps_class_name}>
				        				<a aria-expanded='false'>
					        				Plans and Maps
				        				</a>
				        			</li>
	        					)
	        				}
	        			})()}
	        			{(() => {
	        				if(
										current_user &&
										!current_user.owner_account &&
										this.props.users.editing_user
									) {
	        					return (
	        						<li
				        				onClick={this.handleClickCompanyTab}
				        				className={plans_and_maps_class_name}>
				        				<a aria-expanded='false'>
					        				Company
				        				</a>
				        			</li>
	        					)
	        				}
	        			})()}
	        		</ul>
			        <form className="form-horizontal form-bordered" autoComplete="off">
		        		{(() => {
		        			if(this.props.users.open_tab === 'login_cred' || this.props.users.open_tab === '')
		        				return (
		        					<div className='tab-content login-credentials'>
			        					<div className="form-group mb-lg">
			        						<div className='row'>
												    <h3 className='user-form-input-label'>Login Credentials</h3>
												  </div>
												  <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
												    <div className="form-group">
												    	{(() => {
												      	if(current_user.is_admin && this.props.user && !(current_user._id === this.props.user._id)) {
												      		return (
												      			<div>
												      				<div className='row mt-lg'>
												      					<div className='col-md-12 col-xs-12'>
												      						<div className='col-md-2 col-xs-2'>
																	        	<div
																	        		className='switch switch-sm switch-success'
																	        		onClick={this.handleEnableAccountChange}>
																	        		<div className={enabled_account_class_name}>
																	        			<div className='on-background background-fill' />
																	        			<div className='state-background background-fill' />
																	        			<div className='handle' />
																	        		</div>
																	        	</div>
																	        </div>
																        	<div className='col-md-19 col-xs-19'>
																		        <h4>Account Enabled</h4>
																	        </div>
																        </div>
															        </div>
																			<div className='row mt-lg'>
																				<div className='col-md-12 col-xs-12'>
																					<div className='col-md-2 col-xs-2'>
																						<div
																							className='switch switch-sm switch-success'
																							onClick={this.handleEnableAccountValidationChange}>
																							<div className={enabled_account_validation_class_name}>
																								<div className='on-background background-fill' />
																								<div className='state-background background-fill' />
																								<div className='handle' />
																							</div>
																						</div>
																					</div>
																					<div className='col-md-19 col-xs-19'>
																						<h4>Account Validation Enabled</h4>
																					</div>
																				</div>
																			</div>
															        <hr className='dotted short' />
														        </div>
												      			)
												      	}
												      })()}
												      <div className="col-xs-12">
												        <div className="col-md-12 control-label">Username</div>
												        <input
												        	onChange={this.handleChange}
												        	type="text"
												        	className="form-control mb-lg"
												        	name="username"
												        	value={user.username}
												        	placeholder="Username" />
												      </div>
												      {(() => {
												      	if(this.props.hasPermission('/Account Management/Roles/Assign/') &&
												      		(users.tmp_user && !(users.user._id === users.tmp_user._id))) {
												      		let roles;
												      		if(users.user.is_admin && (users.tmp_user.owner_account || users.proxy_account))
												      			roles = users.tmp_user_roles
												      		else
												      			roles = this.props.roleManagement.roles
												      		return (
												      			<div className="col-xs-12">
															        <div className="col-md-12 control-label">Role</div>
															        <select
															        	onChange={this.handleChange}
															        	name="role"
															        	value={user.role}
															        	className="form-control mb-lg">
															        	{roles.map(this.renderRoles)}
															        </select>
															      </div>
												      		)
												      	}
												      })()}
												      <div className={emailClass}>
													      <div className="col-xs-12">
													        <div className="col-md-12 control-label">Email</div>
													        <input
													        	type="text"
													        	className="form-control mb-lg"
													        	onChange={this.handleChange}
													        	name="email"
													        	value={user.email}
													        	placeholder="Email" />
													          {(()=>{
													            if(this.state.dirty && (!user.email_valid || !user.email)) {
													              return <label className="error">Please enter a valid email address. name@example.com</label>
													            }
													          })()}
													      </div>
													    </div>
												    </div>
												  </div>
												</div>
											</div>
			        			)
		        		})()}
		        		{(() => {
		        			if(users.open_tab === 'password')
		        				return (
					            <div className='tab-content password'>
		        						<div className="form-group">
		        							<div className='row'>
							              <h3 className='user-form-input-label'>Password</h3>
								          </div>
								          <div className='form-group'>
									          <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
									          	<div className={passwordClass}>
									          		<div className='col-md-6 col-xs-12'>
									              	<div className="col-md-12 control-label">Enter Password</div>
									                <input
									                	type="password"
									                	className="form-control mb-lg "
									                	onChange={this.handleChange}
									                	name="password"
									                	value={user.password}
									                	placeholder="Password" />
									                {(()=>{
									                  if(!user.password_valid)
									                    return (<label className="error">{user.password_error}</label>);
									                  else
									                    return '';
									                })()}
									              </div>
								              </div>
								              <div className={passwordConfirmClass}>
									              <div className="col-md-6 col-xs-12">
									                <div className="col-md-12 control-label">Confirm Password</div>
									                <input
									                	type="password"
									                	className={"form-control mb-lg "}
									                	onChange={this.handleChange}
									                	name="password_confirm"
									                	value={user.password_confirm}
									                	placeholder="Confirm Password" />
									                {(()=>{
									                  if(!_self.password_match)
									                    return (<label className="error">{user.password_match_error}</label>);
									                  else
									                    return '';
									                })()}
									              </div>
									            </div>
								            </div>
								          </div>
						            </div>
					            </div>
		        				)
		        		})()}
		        		{(() => {
		        			if(this.props.users.open_tab === 'gen_info') {
		        				return (
		        					<div className='tab-content general-user-info'>
		        						<div className="form-group">
		        							<div className='row'>
							              <h3 className='user-form-input-label'>General User Info</h3>
							            </div>
							            <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
							              <div className="form-group">
							                <div className="col-md-6">
							                  <div className="col-md-12 control-label">First Name</div>
							                  <input
							                  	type="text"
							                  	className="form-control mb-lg"
							                  	onChange={this.handleChange}
							                  	name="name.first"
							                  	value={user.name.first}
							                  	placeholder="First Name" />
							                </div>
							                <div className="col-md-6">
							                  <div className="col-md-12 control-label">Last Name</div>
							                  <input
							                  	type="text"
							                  	className="form-control mb-lg"
							                  	onChange={this.handleChange}
							                    name="name.last" value={user.name.last} placeholder="Last Name" />
							                </div>
							              </div>
							              <div className="form-group">
							                <div className="col-xs-12">
							                  <div className="col-md-12 control-label">Personal Phone</div>
							                  <input
							                  	onChange={this.handleChange}
							                  	type="text"
							                  	className="form-control mb-lg"
							                  	name="personal_phone"
							                  	value={personal_phone}
							                  	placeholder="Personal Phone" />
							                </div>
							                <div className="col-xs-12">
							                  <div className="col-md-12 control-label">Work Phone</div>
							                  <input
							                  	onChange={this.handleChange}
							                  	type="text"
							                  	className="form-control mb-lg"
							                  	name="work_phone"
							                  	value={work_phone}
							                  	placeholder="Work Phone" />
							                </div>
							              </div>
								          </div>
								        </div>
									  		<div className="form-group mb-lg">
									  			<div className='row'>
									          <h3 className='user-form-input-label'>Mailing Address</h3>
									        </div>
									        <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
									          <div className="col-xs-12 control-label">Street</div>
									          <input
									          	type="text"
									          	className="form-control mb-lg"
									          	onChange={_self.handleChange}
									          	name="address.street"
									          	value={user.address.street}
									          	placeholder="Street" />
									          <div className="col-xs-12 control-label">City</div>
									          <input
									          	type="text"
									          	className="form-control mb-lg"
									          	onChange={_self.handleChange}
									          	name="address.city"
									          	value={user.address.city}
									          	placeholder="City" />
									          <div className="col-xs-12 control-label">Zip</div>
									          <input
									          	type="text"
									          	className="form-control mb-lg"
									          	onChange={_self.handleChange}
									          	name="address.zip"
									          	value={user.address.zip}
									          	placeholder="Zip" />
									          <div className="col-xs-12 control-label">State</div>
									          <StateSelect onChange={_self.handleChange} name="address.state" value={user.address.state} className="form-control mb-lg" />
									        </div>
									      </div>
									  		<div className="form-group">
									  			<div className="col-xs-12 col-md-4">
									           {Error}
									  			</div>
												</div>
		        					</div>
	        					)
		        			}
		        		})()}
		        		{(() => {
		        			if(this.props.users.open_tab === 'profile_pic')
		        				return (
		        					<div className='tab-content profile_pic'>
			        					<div className="form-group mb-lg">
			        						<div className='row'>
												    <h3 className='user-form-input-label'>Upload Profile Picture</h3>
												  </div>
												  <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
												    <FileUploader
												    	endpoint={`/upload/user/${user._id}/profile_picture`}
												    	/>
												  </div>
												</div>
												<div className="form-group mb-lg">
			        						<div className='row'>
												    <h3 className='user-form-input-label'>Choose Avatar</h3>
												  </div>
												  <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
												    <AvatarSelector handleChange={this.handleChange}/>
												  </div>
												</div>
											</div>
		        				)
		        		})()}
		        		{(() => {
		        			if(this.props.users.open_tab === 'features')
		        				return (
		        					<div className='tab-content features'>
			        					<div className="form-group mb-lg">
			        						<div>
												    <h3 className='user-form-input-label'>Features</h3>
												  </div>
												  <div className="col-md-10 col-md-offset-1">
												    <Features
												    	numOfColumns={2}
												    	featuresColumnClassName='col-lg-6 col-md-12'
										    			featureClassName='panel'
										    			featuresHeadingOpenClassName='feature-heading-open'
										    			featuresHeadingClosedClassName='feature-heading-closed'
										    			parentFeatureWrapperClassName='parent-feature-wrapper'
										    			parentFeatureBodyClassName='parent-feature-body'
										    			nestedFeatureWrapperClassName='nested-feature-wrapper'
										    			nestedFeatureBodyClassName='nested-feature-body'
										    			handleChange={this.handleChange}
												    />
												  </div>
												</div>
											</div>
			        			)
		        		})()}
		        		{(() => {
		        			if(this.props.users.open_tab === 'plans_maps') {
		        				let populated_features = this.props.users.tmp_user_features;
		        				return (
		        					<div className='tab-content'>
		        						<div className="form-group mb-lg">
								          <h3 className='user-form-input-label'>Plans</h3>
								          <div className='col-md-12 col-xs-12'>
										        <PlanSelector
									          	currentPlans={populated_features.filter(f => f.path.startsWith('/Plans'))}
									          	handleChange={this.handleChange}
									          />
								          </div>
												</div>
												{(() => {
													if(this.props.users.user.is_admin)
														return (
															<div className="form-group mb-lg">
				        								<div className='col-md-12 col-xs-12'>
												          <h3 className='user-form-input-label'>Number of Users in Account</h3>
													        <input
													        	className="form-control mb-lg"
													        	name='account_user_limit'
												          	onChange={this.handleChange}
												          	placeholder='Number of users allowed in this account'
												          	value={user.account_user_limit}
												          />
											          </div>
															</div>
															)
												})()}
												<div className="form-group mb-lg">
								          <h3 className='user-form-input-label'>Maps</h3>
								          <div className='col-md-10 col-md-offset-1 col-xs-8 col-xs-offset-2'>
										        <MapSelector
										        	usersCurrentMaps={this.state.purchased_maps}
										        	handleChange={this.handleChange}
										        />
									        </div>
												</div>
		        					</div>
		        				)
		        			}
		        		})()}
		        		{(() => {
		        			if(this.props.users.open_tab === 'company') {
		        				return (
		        					<div className='tab-content profile_pic'>
			        					<div className="form-group mb-lg">
													<div className='row'>
														<div className='col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'>
													    <h3 className='user-form-input-label'>Company Name</h3>
														</div>
												  </div>
													<div className='row'>
														<div className='col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'>
														<input
															className='form-control'
															name='company_name'
															value={user.company_name}
															onChange={this.handleChange}
														/>
														</div>
												  </div>
			        						<div className='row'>
												    <h3 className='user-form-input-label'>Upload Company Logo</h3>
												  </div>
												  <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
												    <FileUploader
												    	endpoint={`/upload/user/${user._id}/logo`}
												    	/>
												  </div>
												</div>
											</div>
		        				)
		        			}
		        		})()}
					    </form>
					  </div>
					</div>
        );
    }
}

var mapStateToProps = function (state) {
    const {users, roleManagement} = state;
    return {
        users : users,
        user : users.tmp_user,
        roleManagement
    }
}

UserForm.contextTypes = {
    router : PropTypes.object
}

export default connect(mapStateToProps, Actions)(UserForm);



// WEBPACK FOOTER //
// ./src/browser/components/users/userForm.js